import * as React from 'react';
import { SVGProps } from 'react';

const IconSettingsStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.29 1a.21.21 0 0 1 .21.21v1.081c.347.14.67.329.96.556l.938-.541a.21.21 0 0 1 .288.077l1.29 2.234a.21.21 0 0 1-.078.286l-.938.54a4.03 4.03 0 0 1 .001 1.11l.938.543c.1.058.134.187.077.287l-1.29 2.234a.21.21 0 0 1-.288.076l-.937-.542c-.29.228-.614.416-.961.557v1.082a.21.21 0 0 1-.21.21H4.71a.21.21 0 0 1-.21-.21V9.707a3.994 3.994 0 0 1-.96-.556l-.937.542a.21.21 0 0 1-.288-.076l-1.29-2.234a.21.21 0 0 1 .077-.287l.936-.542a4.035 4.035 0 0 1 .001-1.11l-.936-.54a.21.21 0 0 1-.078-.287l1.29-2.234a.21.21 0 0 1 .287-.077l.938.54c.29-.226.613-.414.96-.554V1.21A.21.21 0 0 1 4.71 1h2.58ZM5.5 3.041a2.998 2.998 0 0 0-1.812 1.047l-.902-.52-.5.865.904.521A2.99 2.99 0 0 0 3 6c0 .367.069.719.19 1.044l-.904.523.5.866.902-.522c.45.543 1.086.925 1.812 1.047V10h1V8.958a2.996 2.996 0 0 0 1.812-1.047l.902.522.5-.866-.904-.522A2.99 2.99 0 0 0 9 6c0-.368-.07-.72-.191-1.046l.905-.521-.5-.866-.902.52A2.997 2.997 0 0 0 6.5 3.042V2h-1v1.041Z"
    />
  </svg>
);
export default IconSettingsStrokedSizeXs;
